import Vue from 'vue'
import axios from 'axios'

const apiClient = axios.create({
  baseURL: '/actions/mailchimp-subscribe/audience/subscribe',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

const el = document.querySelector('#signup-form')
if (el !== null) {
  const vm = new Vue({
    delimiters: ['[[', ']]'],
    data: {
      formData: {
        audienceId: '',
        merge_fields: {
          STATUS: 'Active'
        }
      },
      errors: [],
      success: false
    },
    methods: {
      checkForm () {
        this.errors = []
        if (!this.formData.email) {
          this.errors.push('Email address is required.')
        } else if (!this.validEmail(this.formData.email)) {
          this.errors.push('Valid email required.')
        }
        if (!this.errors.length) {
          this.formSubmit()
        }
      },
      formSubmit () {
        apiClient.post('/', this.formData)
          .then(response => {
            if (response.data.success === true) {
              this.success = true
            } else {
              this.errors = []
              this.errors.push(response.data.message)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },
      validEmail (email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
      }
    },
    beforeMount: function () {
      const tokenName = el.querySelector('#csrf-token').name
      this.formData[tokenName] = el.querySelector('#csrf-token').value
      this.formData['audienceId'] = el.querySelector('#audience-id')?.value ?? ''
    }
  })
  vm.$mount(el)
}
